import axios from "axios";
import { useAuthCtx } from "context/AuthContext";
import { SessionDataContext } from "context/SessionDataContext";
import { Navigate, Outlet } from "react-router-dom";

const PrivateRoute = () => {
  const { user, setUser } = useAuthCtx();
  axios.interceptors.response.use(
    //TODO when roles are more iplemented for specific endpoints this wont work as well.
    (response) => {
      if (response.status === 401) {
        setUser(null);
      }
      return response;
    },
    (error) => {
      if (error.response.status === 401) {
        setUser(null);
      }
      return error.response;
    }
  );

  if (!user) return <Navigate to="/login" />;
  return (
    <SessionDataContext>
      <Outlet />
    </SessionDataContext>
  );
};

export default PrivateRoute;
